<route-meta>
{
  "requiresAuth": true
}
</route-meta>

<template>
  <div class="extension__index">
    <extension-index
      :entity="entity"
      :createName="createName"
      :entries="entries"
      :title="title"
    ></extension-index>
  </div>
</template>


<script>
import ExtensionIndex from '@/pages/extension/index';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'menus-index',
  data() {
    return {
      entity: 'menus',
    };
  },
  components: {
    ExtensionIndex,
  },
  computed: {
    ...mapState({
      entries: state => state.menus.entries,
    }),
    createName() {
      return `${this.entity}-create`;
    },
    title() {
      return 'Menus';
    },
  },
  methods: mapActions('menus', ['add']),
  created() {
    this.$store.dispatch(`${this.entity}/get`);
    this.$store.dispatch('breadcrumbs/set', [
      {
        name: 'menus-index',
        label: 'Menus',
      },
    ]);
  },
};
</script>
